<template>
  <div class="settlement-apply-list">
    <el-form inline :model="criteria" size="small">
      <el-form-item label="采购客户：">
        <el-input v-model.trim="criteria.orgName" placeholder="请输入公司抬头"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="startSearch">确定</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="datas" style="width: 100%">
      <el-table-column prop="buyerOrgName" label="采购客户" min-width="28%"></el-table-column>
      <el-table-column
        prop="pendingOrderNum"
        label="待结算订单数"
        min-width="12%"
      ></el-table-column>
      <el-table-column
        prop="pendingDispatchNum"
        label="待结算提单数"
        min-width="12%"
      ></el-table-column>
      <el-table-column label="实提数量/重量" min-width="18%">
        <template v-slot="scope">
          {{ scope.row.actualQuantity }}件/{{ scope.row.actualWeight | formatWeight }}吨
        </template>
      </el-table-column>
      <el-table-column label="待结算金额" min-width="18%">
        <template v-slot="scope">
          <span>{{ scope.row.settleEstimateAmount | currencyFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="12%">
        <template v-slot="scope">
          <el-button type="text" @click="goDetail(scope)">生成结算单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin:20px;text-align:right;"
      v-show="total > 0"
      @size-change="handleSizeChange"
      @current-change="paging"
      :current-page="criteria.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="criteria.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
const defaultCriteria = {
  orgName: '',
  pageNo: 1,
  pageSize: 10
}

export default {
  name: 'SettlementApplyList',
  data() {
    return {
      datas: [],
      total: 0,
      criteria: {
        ...defaultCriteria
      }
    }
  },
  filters: {
    appendPrefix(amount) {
      if (amount === 0) {
        return '--'
      }
      if (amount < 0) {
        return '待退款 '
      } else {
        return '待补款 '
      }
    }
  },
  methods: {
    goDetail(scope) {
      const { buyerOrgId: orgId } = scope.row
      this.$router.push({ name: 'SettlementApplyDetail', params: { orgId } })
    },
    reset() {
      this.criteria = { ...defaultCriteria }
      this.startSearch()
    },
    paging(page) {
      this.criteria.pageNo = page
      this.startSearch()
    },
    handleSizeChange(val) {
      this.criteria.pageSize = val
      this.startSearch()
    },
    async startSearch() {
      const request = {}
      Object.keys(this.criteria).forEach(key => {
        if (this.criteria[key]) {
          request[key] = this.criteria[key]
        }
      })
      const { success, data } = await this.$post('settle.seller.querySettleApplyOrg', { request })
      if (success && data) {
        const { totalNum, settleApplyOrgVOList } = data[0]
        this.total = totalNum
        this.datas = settleApplyOrgVOList
      }
    }
  },
  created() {
    this.startSearch()
  },
  activated() {
    this.startSearch()
  }
}
</script>
